export default {
  booking: {
    title: '예약 정보',
    bookingTitle: '예약 제목',
    seatType: '좌석 유형',
    attendanceDate: '참가일',
    participationTime: '탑승 일시',
    trainModel: '열차 차종',
    seatInfo: '좌석',
    reservationCount: '예약인원',
    viewDetail: '예약 상세 정보',
    bookingRange: {
      oneMonth: '1개월 이내의 예약',
      threeMonths: '3개월 이내의 예약',
      sixMonths: '6개월 이내의 예약'
    },
    adultTicket: '성인 티켓',
    childTicket: '어린이 티켓',
    status: {
      paymentPending: '결제대기',
      paid: '예약 절차 완료（발권 확인 중）',
      confirmed: '예약 성공, 티켓이 발행되었습니다',
      cancelPending: '취소 중',
      cancelled: '취소됨',
      refunded: '환불됨',
      paymentExpired: '결제 만료',
      completed: '완료됨',
      confirmFailed: '확인 실패'
    }
  },
  bookingDetail: {
    title: '예약 정보',
    travelInfo: '여행 정보',
    digitalTicket: '전자티켓',
    meetingPoint: '승차 장소 안내',
    beforeTrip: '승차 전 주의사항',
    bookingAction: '예약 작업',
    cancelBooking: '예약 취소',
    cancelConfirmPolicy: '취소 정책을 확인하세요:',
    cancelTip:
      '예약 후 취소를 원하는 경우, 출발 시간 1시간 전까지 취소 처리를 해주세요. 그 이후에는 취소가 불가능하며, 환불도 불가능합니다. 주의해주세요.',
    sendToEmail: '이메일로 보내기',
    attendanceDate: '탑승일',
    customerName: '예약자명',
    email: '이메일',
    actualPayment: '결제금액',
    orderId: '예약 ID',
    orderCompletionTime: '예약 완료 시간',
    digitalTicketValidPeriod: 'QR 코드는 출발 당일만 유효합니다',
    digitalTicketWaiting: '*주문 확인 후, 전자티켓이 여기에 표시됩니다',
    sending: '전송 중...',
    sendToEmailSuccess: '이메일 전송 성공, 이메일을 확인해주세요'
  }
};
